import React from "react";
import { DisconnectionPage, DisconnectionPageProps } from "./DisconnectionPage";

export const DEFAULT_DISCONNECTION_CONTENT: DisconnectionPageProps = {
  tabTitle: "",
};

export const DisconnectionPageContainer: React.FC = () => {
  return <DisconnectionPage {...DEFAULT_DISCONNECTION_CONTENT} />;
};
